import { cx } from '../cx';

// temp_RangeInput — 임시 공통 컴포넌트(UI파트 검수 후 승격 대상). 처음 쓴 곳: 인디포트폴리오 AI 시공사례.
// 라벨·현재 값이 붙은 슬라이더. ui-core 에 슬라이더(range)가 없다.
export interface TempRangeInputProps {
  label: string;
  min: number;
  max: number;
  step: number;
  value: number;
  /** 화면에 보일 값 (예: 0.12em · 80% · 15°) */
  display: string;
  onChange: (value: number) => void;
  className?: string;
}

export function Temp_RangeInput({ label, min, max, step, value, display, onChange, className = '' }: TempRangeInputProps) {
  return (
    <label className={cx('flex flex-col gap-xs text-caption text-text-secondary', className)}>
      <span className="flex justify-between">
        {label}
        <em className="font-semibold not-italic text-text">{display}</em>
      </span>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        aria-valuetext={display}
        className="w-full accent-[var(--gt-primary)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-group"
        onChange={(e) => onChange(+e.target.value)}
      />
    </label>
  );
}
